import React, { useMemo } from "react";
import { CategoryChart } from "../processors";
// import { Figure } from "../Figure";
// import { prefixValue, suffixValue } from "../processors";
import { FigureHorStackBarKpiProvider } from "../categoryChartQueryFns";
// import { Paragraph } from "../Paragraph";
import { useCategoryContext } from "../Context";
// import { CategoryTheme } from "../misc";
// import { StackHorBarWithData } from "../LineWithAverageData";
// import { getColor, getHighlightColors } from "../../themes";
// import _ from "lodash";
import { HorizontalChartProviders, HorizontalChartProvidersProps } from "./HorizontalChartProviders";

interface HorizontalChartProviderProps extends FigureHorStackBarKpiProvider {
    categoryChart: CategoryChart;
}

export const HorizontalChartProvider: React.FC<HorizontalChartProviderProps> = ({
    categoryChart,
    title,
    figure,
    graph,
    footer,
    unit,
    waterProvider,
    year
}) => {
    const { category } = useCategoryContext();

    const props: HorizontalChartProvidersProps = useMemo(() => {
        return {
            categoryChart,
            title,
            footer,
            unit,
            waterProviders: [waterProvider],
            year,
            elements: [
                {
                    figure,
                    graph
                }
            ]
        };
    }, [categoryChart, title, figure, graph, footer, unit, waterProvider, year]);

    if (!category) return null;

    return <HorizontalChartProviders {...props} />;
};
